export default __webpack_public_path__ + "static/media/026-sea.87d2ef44.svg";